module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cm-7eff011cd2036bfc5df42647682d9402.svg";